import { defineMessages } from 'react-intl';

export default defineMessages({
    makeChanges: {
        id: 'ml.policychange.interestedparties.Make Changes',
        defaultMessage: 'Make Changes'
    },
    vehicleX: {
        id: 'ml.policychange.interestedparties.VEHICLE x',
        defaultMessage: 'VEHICLE {vehicleIndex}'
    },
    nextBaseDescription: {
        id: 'ml.policychange.interestedparties.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.interestedparties.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    updateInterestdParties: {
        id: 'ml.policychange.interestedparties.updateInterestedParties',
        defaultMessage: 'Update interested parties'
    },
      namedNonOwnerHeading: {
        id: 'ml.policychange.interestedparties.namedNonOwnerHeading',
        defaultMessage: 'Named Non-Owner'
    },
       namedNonOwnerHeadingNP: {
        id: 'ml.policychange.interestedparties.namedNonOwnerHeadingNP',
        defaultMessage: 'Non Owner'
    },

});